import {Controller} from "@stimulus/core"
import { isPreview } from "../support"

require("select2/dist/js/select2.full.js")
require("../../../../vendor/front/js/hs.core")
require("../../../../vendor/front/js/hs.select2")

export default class extends Controller {
  connect() {
    if (isPreview()) {
      return false;
    }

    // Деинициализируем текущий экземпляр Select2, если он существует
    this.teardownSelect2();

    // Инициализируем новый экземпляр Select2
    this.initializeSelect2();

    return true;
  }

  disconnect() {
    this.teardownSelect2();
  }

  initializeSelect2() {
    let options = {};

    // Проверяем, нужно ли использовать AJAX
    if(this.element.dataset.ajaxUrl) {
      options = {
        ajax: {
          url: this.element.dataset.ajaxUrl,
          dataType: 'json',
          delay: 250,
          data: function(params) {
            return {
              query: params.term // Термин поиска
            };
          },
          processResults: function(data) {
            return {
              results: data.results // Убедитесь, что результаты соответствуют ожиданиям Select2
            };
          },
          cache: true
        },
        minimumInputLength: 2,
        // Поддержка множественного выбора и начальных значений
        templateSelection: function (data, container) {
          return data.text || data.id;
        }
      };
    }

    // Инициализация Select2 с дополнительными опциями
    $(this.element).select2($.extend({}, options));

    // Инициализация через HSSelect2 (если требуется дополнительная логика от HSCore)
    $.HSCore.components.HSSelect2.init($(this.element));
  }

  teardownSelect2() {
    if ($(this.element).data('select2')) {
      $(this.element).select2('destroy');
    }
  }
}